import {Injectable, Injector} from '@angular/core';
import {Observable} from 'rxjs';


import {BaseService} from '../base/base.service';
import {Partner} from '../../models/lookups/partner';
import {Query} from '../../models/query/query';
import {WebMethodResult} from '../../models/web-method-result';
import {AppModulePath} from '../../models/app-module-path';
import {HttpClient} from '@angular/common/http';
import {PlatformLocation} from '@angular/common';
import {catchError, map} from 'rxjs/operators';
import { KontaktOsoba } from 'app/models/lookups/kontaktOsoba';
import { Address } from 'app/models/lookups/address';

@Injectable()
export class PartnerService extends BaseService {
  private listUrl = '/api/partner/list';
  private postUrl = '/api/partner/save';
  private deleteUrl = '/api/partner/delete/';
  private findByTinUrl = '/api/partner/find_by_tin/';
  private findByNinUrl = '/api/partner/find_by_nin/';
  private importUrl = '/api/partner/import';
  private detailsUrl = '/api/partner/details/';
  private saveKontaktOsobaUrl = '/api/ko/save';
  private adresaUrl = '/api/address/save';


  constructor(protected injector: Injector,
              protected http2: HttpClient,
              protected platformLocation: PlatformLocation) {
    super(injector, http2, platformLocation);
  }

  list(qry: Query): Observable<Partner[]> {
    const url = this.listUrl + '?q=' + encodeURIComponent(JSON.stringify(qry));
    return this.get<Partner[]>(url, AppModulePath.PARTNER).pipe(
      map(res => res.map(obj => new Partner(obj))),
      catchError(this.handleError));
  }

  save(partner: Partner): Observable<Partner> {
    return this.post<Partner>(this.postUrl, AppModulePath.PARTNER, partner).pipe(
      map(res => new Partner(res)),
      catchError(this.handleError));
  }

  delete(id: string): Observable<WebMethodResult> {
    return this._delete<WebMethodResult>(this.deleteUrl + id, AppModulePath.PARTNER).pipe(
      map(res => new WebMethodResult(res)),
      catchError(this.handleError));
  }

  findByTin(tin: string): Observable<Partner> {
    return this.get<Partner>(this.findByTinUrl + tin, AppModulePath.PARTNER).pipe(
      map(res => new Partner(res)),
      catchError(this.handleError));
  }

  findByNin(nin: string): Observable<Partner> {
    return this.get<Partner>(this.findByNinUrl + nin, AppModulePath.PARTNER).pipe(
      map(res => new Partner(res)),
      catchError(this.handleError));
  }

  uploadImportFile(formData: FormData): Observable<Blob> {
    return this.uploadFile(this.importUrl, AppModulePath.ITEM, formData).pipe(
      // .map(res => res)
      catchError(this.handleError));
  }

   getPartnerDetails(partnerId: string): Observable<Partner> {
    return this.get<Partner>(this.detailsUrl + partnerId, AppModulePath.PARTNER).pipe(
      map(res => new Partner(res)), // mapira JSON na Partner model
      catchError(this.handleError)
    );
  }

  saveKontaktOsoba(kontaktOsoba: KontaktOsoba): Observable<KontaktOsoba> {
  return this.post<KontaktOsoba>(this.saveKontaktOsobaUrl, AppModulePath.PARTNER, kontaktOsoba).pipe(
    map(res => res),
    catchError(this.handleError)
  );
  }

  saveAdresa(adresa: Address): Observable<Address> {
  return this.post<Address>(this.adresaUrl, AppModulePath.PARTNER, adresa).pipe(
    map(res => res),
    catchError(this.handleError)
  );
  }
}
